import warning, { resetWarned } from "rc-util/es/warning";
export { resetWarned };
export default (function (valid, component, message) {
  warning(valid, "[antd: ".concat(component, "] ").concat(message));
});
//# sourceMappingURL=warning.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/_util/warning.js
// module id = 16
// module chunks = 0